import React from "react";
import UserForm from "./UserForm";

const AddUser = () => {
  return <UserForm title="New User" addUser={true} />;
};
export default AddUser;
